import React from 'react';
import CustomDatePicker from '../CustomDatePicker/CustomDatePicker';

import 'react-datepicker/dist/react-datepicker.css';
import './DateRange.css';

const DateRange = props => {
  return (
    <div className={`efup-date-range ${props.customClasses ? props.customClasses : ""}`}>
      <CustomDatePicker
        selectedDate={props.startDate}
        setDate={props.setStartDate}
        selectsStart
        startDate={props.startDate}
        endDate={props.endDate}
        setCalendarOpen={props.setStartCalendarOpen}
        type='range-start'
        isClearable={props.isClearable}
      />
      <div className="date-range-label">-</div>
      <CustomDatePicker
        selectedDate={props.endDate}
        setDate={props.setEndDate}
        selectsEnd
        startDate={props.startDate}
        endDate={props.endDate}
        setCalendarOpen={props.setEndCalendarOpen}
        type='range-end'
        isClearable={props.isClearable}
      />
    </div>
  );
};

export default DateRange;